import React, { FC } from 'react'
import { ReactSVG } from "react-svg";

interface Props {
  className?: string
  label?: string
  color?: string
  icon?: string
  message?: string
}

const Status: FC<Props> = ({ label, color, icon, className, message }) => {
  return (
    <div
      className={`status _${color} ${className ?? ''}`.trim()}
    >
      <div className={'status__label'}>
        <ReactSVG
          src={`/i/svg/${icon}.svg`}
          className={'svg-icon'}
          wrapper={'span'}
        />
        {label}
      </div>
      {message && (
        <div className={'status__comment'}>
          {message}
        </div>
      )}
    </div>
  )
}

export default Status
